export default __webpack_public_path__ + "static/media/topic0-bg3.e4973132.png";